import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  INSERT_LINE_BREAK_COMMAND,
  INSERT_PARAGRAPH_COMMAND,
  KEY_ENTER_COMMAND,
  PASTE_COMMAND,
  type LexicalCommand
} from "lexical"
import { useEffect } from "react"

export const SingleLinePlugin = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const commands = [
      KEY_ENTER_COMMAND,
      INSERT_PARAGRAPH_COMMAND,
      INSERT_LINE_BREAK_COMMAND
    ].map((command) =>
      editor.registerCommand(
        command as LexicalCommand<unknown>,
        () => true,
        COMMAND_PRIORITY_CRITICAL
      )
    )

    const unregisterPaste = editor.registerCommand(
      PASTE_COMMAND as ClipboardEvent,
      (event: ClipboardEvent) => {
        const isClipboardEvent = event instanceof ClipboardEvent

        if (!isClipboardEvent) return false

        const clipboardData = event.clipboardData

        if (clipboardData) {
          const text = clipboardData.getData("text/plain")
          const singleLineText = text.replace(/[\r\n]+/g, " ")
          const selection = $getSelection()

          if ($isRangeSelection(selection)) selection.insertText(singleLineText)
        }

        return true
      },
      COMMAND_PRIORITY_CRITICAL
    )

    return () => {
      commands.forEach((unregister) => unregister())
      unregisterPaste()
    }
  }, [editor])

  return null
}
